import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  // County data
  personaByCounty: null,
  loadingPersonaByCounty: false,
  personaByCountyError: null,

  // Congressional District data
  personaByCongressionalDistrict: null,
  loadingPersonaByCongressionalDistrict: false,
  personaByCongressionalDistrictError: null,

  // Census Tract data
  personaByCensusTract: null,
  loadingPersonaByCensusTract: false,
  personaByCensusTractError: null
}

const personaMapDataSlice = createSlice({
  name: 'personaMapData',
  initialState,
  reducers: {
    // County data actions
    setPersonaByCounty: (state, action) => {
      state.personaByCounty = action.payload
    },
    setLoadingPersonaByCounty: (state, action) => {
      state.loadingPersonaByCounty = action.payload
    },
    setPersonaByCountyError: (state, action) => {
      state.personaByCountyError = action.payload
    },

    // Congressional District data actions
    setPersonaByCongressionalDistrict: (state, action) => {
      state.personaByCongressionalDistrict = action.payload
    },
    setLoadingPersonaByCongressionalDistrict: (state, action) => {
      state.loadingPersonaByCongressionalDistrict = action.payload
    },
    setPersonaByCongressionalDistrictError: (state, action) => {
      state.personaByCongressionalDistrictError = action.payload
    },

    // Census Tract data actions
    setPersonaByCensusTract: (state, action) => {
      state.personaByCensusTract = action.payload
    },
    setLoadingPersonaByCensusTract: (state, action) => {
      state.loadingPersonaByCensusTract = action.payload
    },
    setPersonaByCensusTractError: (state, action) => {
      state.personaByCensusTractError = action.payload
    },

    // Clear all data
    clearPersonaMapData: (state) => {
      state.personaByCounty = null
      state.loadingPersonaByCounty = false
      state.personaByCountyError = null
      state.personaByCongressionalDistrict = null
      state.loadingPersonaByCongressionalDistrict = false
      state.personaByCongressionalDistrictError = null
      state.personaByCensusTract = null
      state.loadingPersonaByCensusTract = false
      state.personaByCensusTractError = null
    }
  }
})

export const {
  setPersonaByCounty,
  setLoadingPersonaByCounty,
  setPersonaByCountyError,
  setPersonaByCongressionalDistrict,
  setLoadingPersonaByCongressionalDistrict,
  setPersonaByCongressionalDistrictError,
  setPersonaByCensusTract,
  setLoadingPersonaByCensusTract,
  setPersonaByCensusTractError,
  clearPersonaMapData
} = personaMapDataSlice.actions

// Selectors
export const selectPersonaByCounty = (state) => state.personaMapData.personaByCounty
export const selectLoadingPersonaByCounty = (state) => state.personaMapData.loadingPersonaByCounty
export const selectPersonaByCountyError = (state) => state.personaMapData.personaByCountyError
export const selectPersonaByCongressionalDistrict = (state) => state.personaMapData.personaByCongressionalDistrict
export const selectLoadingPersonaByCongressionalDistrict = (state) =>
  state.personaMapData.loadingPersonaByCongressionalDistrict
export const selectPersonaByCongressionalDistrictError = (state) =>
  state.personaMapData.personaByCongressionalDistrictError
export const selectPersonaByCensusTract = (state) => state.personaMapData.personaByCensusTract
export const selectLoadingPersonaByCensusTract = (state) => state.personaMapData.loadingPersonaByCensusTract
export const selectPersonaByCensusTractError = (state) => state.personaMapData.personaByCensusTractError

export default personaMapDataSlice.reducer
